import { render, staticRenderFns } from "./ReductionTable.vue?vue&type=template&id=2c2e42ff&"
import script from "./ReductionTable.vue?vue&type=script&lang=js&"
export * from "./ReductionTable.vue?vue&type=script&lang=js&"
import style0 from "./ReductionTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports